<nz-layout>
  <nz-content>
    <ng-container>
      <app-reusable-table title="Travel History" [columns]="['Country', 'Departure Date', 'Arrival Date']"
        [rowFields]="['country', 'departureDate', 'arrivalDate']" [data]="travelHistory" [addComponent]="addComp"
        [deleteFun]="deleteFun" [isLoading]="isLoading" [openModalFun]="openModalFun" [isPreview]="false"
        [addPermissions]="['a-th']" />
    </ng-container>
  </nz-content>
</nz-layout>
